(function($) {
	$(function() {
		$mobileStub = $('.mobileStub'),
		$button = $mobileStub.find('.js-reload');

		$button.on('click', function(){
			window.location.reload(false);
		});
	});
})(jQuery);